import React from "react";
import ProductCard from "./ProductCard";

export default function ProductGrid({ products = [], onAddToCart }) {
  if (!products.length) {
    return (
      <div className="rounded-2xl border border-dashed border-gray-300 bg-white p-8 text-center text-sm text-gray-500">
        Produk belum ditemukan.
      </div>
    );
  }

  return (
    <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
      {products.map((product) => (
        <ProductCard
          key={product.id || product.slug}
          product={product}
          onAddToCart={onAddToCart}
        />
      ))}
    </div>
  );
}
